import {Component, Input} from '@angular/core';
import {AbstractComponent} from "@components";
import {Lookups, ORGANIZER_ROLE, Request} from "@model";
import {INCOMING_REQUESTS, OUTGOING_REQUESTS} from "../../../../../app-routing.module";
import {Router} from '@angular/router';

@Component({
  selector: 'app-requests-page',
  templateUrl: './requests-page.component.html',
  styleUrl: './requests-page.component.scss',
  standalone: false
})
export class RequestsPageComponent extends AbstractComponent{
  @Input('requestStatuses') statuses: Lookups[] = [];
  @Input() languages: Lookups[] = [];
  @Input('requestTypes') types: Lookups[] = [];
  @Input() requests: Request[] = [];
  @Input() userRole: String | undefined;

  view?: RequestsPageComponentView = RequestsPageComponentView.LIST;
  readonly RequestsPageComponentView = RequestsPageComponentView;
  readonly INCOMING_REQUESTS = INCOMING_REQUESTS;
  readonly OUTGOING_REQUESTS = OUTGOING_REQUESTS;



  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    if (this.userRole === ORGANIZER_ROLE) {
      this.view = RequestsPageComponentView.TAB
    }
  }

}

export enum RequestsPageComponentView {
  LIST,
  TAB
}
